import AsyncStorage from '@react-native-async-storage/async-storage';

const HEALTH_SYNC_KEY = '@duel_health_sync_config';

export interface HealthSyncConfig {
  enabled: boolean;
  syncWorkouts: boolean;
  syncBodyweight: boolean;
  lastSyncAt: string | null;
}

const DEFAULT_CONFIG: HealthSyncConfig = {
  enabled: false,
  syncWorkouts: false,
  syncBodyweight: false,
  lastSyncAt: null,
};

export async function getHealthSyncConfig(): Promise<HealthSyncConfig> {
  try {
    const raw = await AsyncStorage.getItem(HEALTH_SYNC_KEY);
    if (!raw) return DEFAULT_CONFIG;
    return { ...DEFAULT_CONFIG, ...JSON.parse(raw) };
  } catch {
    return DEFAULT_CONFIG;
  }
}

export async function setHealthSyncConfig(config: Partial<HealthSyncConfig>): Promise<void> {
  const current = await getHealthSyncConfig();
  const merged = { ...current, ...config };
  await AsyncStorage.setItem(HEALTH_SYNC_KEY, JSON.stringify(merged));
}

/** Scaffold — actual implementation needs native modules (expo-health-connect / react-native-health) */
export async function syncWorkoutToHealth(workout: {
  exercises: string[];
  duration: number;
  calories?: number;
  date: string;
}): Promise<boolean> {
  // TODO: Implement with expo-health-connect
  // TODO: Health sync not yet available
  return false;
}

/** Scaffold — actual implementation needs native modules */
export async function readBodyweightFromHealth(): Promise<number | null> {
  // TODO: Implement with expo-health-connect
  return null;
}
